import { EuiText } from '@elastic/eui';
import { lazy, useContext } from 'react';

import { getAssetSourceIdTypeLabel } from '../model';
import { PageContext } from '../page_container';

const AssetIdAdminLabel = lazy(() => import('./asset_id_admin_label'));

export interface AssetIdLabelProps {
  id: string;
  sourceId: string;
}

export function AssetIdLabel({ id, sourceId }: AssetIdLabelProps) {
  const { settings } = useContext(PageContext);

  if (!settings.accessToken) {
    return (
      <EuiText title={getAssetSourceIdTypeLabel(sourceId)} size="s">
        {id}
      </EuiText>
    );
  }

  return <AssetIdAdminLabel id={id} sourceId={sourceId} />;
}
